import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import * as styles from './FilterDepartureDates.css';

interface IFilterDepartureDatesProps {
  active: boolean;
  empty: boolean;
  filterText: React.ReactNode;
  children: React.ReactNode;
  onFilterClick(): void;
}

// eslint-disable-next-line react/display-name
export const FilterDepartureDates = React.forwardRef<HTMLInputElement, IFilterDepartureDatesProps>(
  ({ active, empty, filterText, children, onFilterClick, ...restProps }, ref) => {
    return (
      <div {...mergeStyles(stylesCommon['container'], styles['container'])} ref={ref} {...restProps}>
        <button
          {...mergeStyles(
            stylesCommon['button'],
            active && stylesCommon['button--active'],
            empty && stylesCommon['button--empty'],
          )}
          onClick={onFilterClick}
        >
          {filterText}
        </button>

        <div {...mergeStyles(stylesCommon['dropdown'], styles['dropdown'])}>{children}</div>
      </div>
    );
  },
);
